import axios from '@/axios'
import API from '@/API'

const PREFIX = 'vehicle_list'

export default {
  datatable(params) {
    return axios.get(`${API.endpoint}/${PREFIX}/datatable`, {
      params: params
    })
  },
  detail(id) {
    return axios.get(`${API.endpoint}/${PREFIX}/detail/${id}`)
  },
  list_brand() {
    return axios.get(`${API.endpoint}/vehicle_brand/select`)
  },
  list_type() {
    return axios.get(`${API.endpoint}/vehicle_type/select`)
  },
  store(data) {
    return axios.post(`${API.endpoint}/${PREFIX}/add`, data)
  },
  update(id, data) {
    return axios.post(`${API.endpoint}/${PREFIX}/update/${id}`, data)
  },
  delete(id) {
    return axios.post(`${API.endpoint}/${PREFIX}/delete/${id}`)
  }
}
